import type { Call } from '@entities/call';
import { CallTypes } from '@entities/call';
import { IdleResultGenerator } from '@main/generators/idle-result.generator';
import { Logger } from '@main/utils/logger';
import { Constants, publishEvent } from '@salesforce/scv-connector-base';
import type { IdleCallEventPublisher } from '@usecases/idle-call.usecase';

export class IdleCallPublisher implements IdleCallEventPublisher {
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }

  async publish(call: Call): Promise<void> {
    const mapCallType = (type: CallTypes): Constants.CALL_TYPE => {
      return type === CallTypes.INBOUND
        ? Constants.CALL_TYPE.INBOUND
        : Constants.CALL_TYPE.OUTBOUND;
    };

    const callResult = IdleResultGenerator.generate(
      call.id,
      mapCallType(call.type),
      call.type === CallTypes.INBOUND ? call.from : call.to,
    );

    this.logger.info('Publisher: Call idle', {
      action: 'IdleCall',
      ...call,
    });

    publishEvent({
      eventType: Constants.VOICE_EVENT_TYPE.HANGUP,
      payload: callResult,
      registerLog: false,
    });
  }
}
